angular.module('dnecom')
    .service('WindowUtils', ["$http", function ($http) {
        var defaultWidth = 630;
        var defaultHeight = 400;

        return {
            openBlank: function(url, params) {
                if (!params) {
                    params = {
                        width: defaultWidth,
                        height: defaultHeight,
                    }
                }

                var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
                var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

                var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
                var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

                var left = ((width / 2) - (params.width / 2)) + dualScreenLeft;
                var top = ((height / 2) - (params.height / 2)) + dualScreenTop;

                params.left = (screen.width - params.width) / 2;
                params.top = (screen.height - (params.height + 50)) / 2;

                var params = _.map(params, function(value, name) {
                    return name + '=' + value;
                }).join(',');

                var openedWindow = window.open(url, '_blank', params);

                if (openedWindow && window.focus) {
                    openedWindow.focus();
                }

                return openedWindow;
            }
        }
    }]);
